import React from 'react';
import { Values } from '@shared/utils/objectEnums';
import { Currencies } from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import styles from './styles/PaymentPartRow.module.css';

type PaymentPartRowProps = {
	identifier: string | number;
	amount: number;
	currency: Values<typeof Currencies>;
};

const PaymentPartRow = ({
	identifier,
	amount,
	currency,
}: PaymentPartRowProps) => (
	<div className={styles.part}>
		<span className={styles.partInvoice}>
			{identifier}
		</span>
		<span className={styles.partAmount}>
			{formatCurrency(amount, currency)}
		</span>
	</div>
);

export default PaymentPartRow;
